import React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component";
import { translate } from "../../base/i18n";

function ImageThumb({ t, item, depthItem, onFocusDocument }) {
    return (
        <div className={`pdf_thumb pdf_thumb_${depthItem === item.uuid ? true : false} noClick`}>
            { item.list.map((value, key) => {
                const isShowItem = depthItem || key === 0 ? true : false;
                if (!isShowItem) return null;
                return (
                    <div key={key} className={`page ${isShowItem ? 'page_show' : 'page_hide'} page_${item.uuid}_${key}`} onClick={() => onFocusDocument(key, item.count)}>
                        <LazyLoadImage
                            draggable="false"
                            alt={<div>{t("document.loading")}</div>}
                            src={value.thumb_url}
                            width={130}   
                            height={130}  
                        />
                        <span className={`paging_label ${isShowItem ? 'page_show' : 'page_hide'} nonSelect`}> { depthItem === item.uuid ? key + 1 : `1 ` } / {item.count}</span>
                    </div>
                )
            })}
        </div> 
    )
}

export default translate(ImageThumb);